// React
import { useState } from "react";
// MUI
import { Avatar, IconButton, Paper, Stack, SvgIcon, Typography } from "@mui/material";
import { AccessTime, Check, ChevronLeftRounded, Phone } from "@mui/icons-material";

// Hooks
import { useLocation } from "@Common/hooks/Location/useLocation";

// Helpers
import { getFormattedDate } from "@dealerwave/dw-layer-date-converter";

// Assets
import { ReactComponent as emailIcon } from "@Auth/assets/icons/email.svg";
import { ReactComponent as inProgressIcon } from "@PayPlans/assets/icons/oneSpanStatus/InProgress.svg";

// Constants
import { DATE_FORMAT } from "@Constants/date";

// Types
import { IEmployeeDetails } from "@PayPlans/types/historical";

type AssigneesDetailsCardProps = {
	assigneeDetails: IEmployeeDetails;
};
export default function AssigneesDetailsCard(props: AssigneesDetailsCardProps) {
	const { assigneeDetails } = props;

	const { timezone } = useLocation() ?? {};

	// States
	const [open, setOpen] = useState(false);

	/********************************************* HANDLERS ************************************************/
	const handleClick = () => {
		setOpen(!open);
	};

	return (
		<Paper className="!shadow-md">
			<Stack direction={"row"} justifyContent={"space-between"}>
				<Stack direction="row" spacing={2} alignItems={"center"} className={"ml-3 mt-3 mr-3 mb-3 w-56"}>
					<Avatar alt="Remy Sharp" src="https://mui.com/static/images/avatar/1.jpg" />
					<Stack direction={"column"}>
						<Typography
							variant="h6"
							noWrap={!open}
							className="w-56"
							style={{
								fontFamily: "Montserrat",
								fontSize: 14,
								color: "#666666",
							}}
						>
							{assigneeDetails?.fullName}
						</Typography>
						<Typography
							variant="body2"
							style={{
								fontFamily: "PtSansProNarrow",
								fontSize: 14.5,
								color: "#666666",
							}}
						>
							{assigneeDetails?.payrollPosition}
						</Typography>
						{open && (
							<Stack direction={"column"}>
								<Stack direction={"row"}>
									<Typography
										variant="body2"
										style={{
											fontFamily: "PtSansProNarrow",
											fontSize: 12,
											color: "#666666",
										}}
									>
										ID: {assigneeDetails.employeeId}
									</Typography>
								</Stack>
								<Stack alignItems={"center"} direction={"row"}>
									<SvgIcon className="!w-3 !h-3 mr-1" component={emailIcon} viewBox="0 -4 24 24" />
									<Typography
										variant="body2"
										className="!w-56"
										noWrap
										style={{
											fontFamily: "PtSansProNarrow",
											fontSize: 12,
											color: "#666666",
										}}
									>
										{assigneeDetails.email}
									</Typography>
								</Stack>
								<Stack alignItems={"center"} direction={"row"}>
									<Phone htmlColor="#666666" className="!w-3 !h-3 mr-1" />
									<Typography
										variant="body2"
										style={{
											fontFamily: "PtSansProNarrow",
											fontSize: 12,
											color: "#666666",
										}}
									>
										{assigneeDetails.phoneNumber}
									</Typography>
								</Stack>
								<Stack direction={"row"} alignItems={"center"}>
									<SvgIcon className="!w-3 !h-3 mr-1" component={inProgressIcon} viewBox="0 0 14 14" />
									<Typography
										variant="body2"
										style={{
											fontFamily: "PtSansProNarrow",
											fontSize: 12,
											color: "#666666",
											fontWeight: 700,
										}}
									>
										{assigneeDetails.inProgressDate === ""
											? "N/A"
											: getFormattedDate(
													assigneeDetails.inProgressDate,
													timezone,
													DATE_FORMAT.abbrDatePaddedOrdinalTime
											  )}
									</Typography>
								</Stack>
								<Stack direction={"row"} alignItems={"center"}>
									<AccessTime htmlColor="#666666" className="!w-3 !h-3 mr-1" />
									<Typography
										variant="body2"
										style={{
											fontFamily: "PtSansProNarrow",
											fontSize: 12,
											color: "#666666",
										}}
									>
										Effective:{" "}
										{assigneeDetails.effectiveDate === ""
											? "N/A"
											: getFormattedDate(assigneeDetails.effectiveDate, "", DATE_FORMAT.monthAbbrDatePadded)}
									</Typography>
								</Stack>
								<Stack direction={"row"} alignItems={"center"}>
									<Check className="!w-3 !h-3 mr-1" />
									<Typography
										variant="body2"
										style={{
											fontFamily: "PtSansProNarrow",
											fontSize: 12,
											color: "#666666",
											fontWeight: 700,
										}}
									>
										Completed:{" "}
										{assigneeDetails.completedDate === ""
											? "N/A"
											: getFormattedDate(
													assigneeDetails.completedDate,
													timezone,
													DATE_FORMAT.abbrDatePaddedOrdinalTime
											  )}
									</Typography>
								</Stack>
							</Stack>
						)}
					</Stack>
				</Stack>
				<IconButton onClick={handleClick} className="h-10 w-10">
					<ChevronLeftRounded className={!open ? "!-rotate-90" : "!rotate-90"} />
				</IconButton>
			</Stack>
		</Paper>
	);
}
